const EMAILS = {
  RANDY: 'randy.setiawan@deltahq.com',
  YUTA: 'yuta.kuratate@deltahq.com',
  ZAMIA: 'zamia.rosa@deltahq.com',
  FERRY: 'ferry.agusta@deltahq.com',
  ARIEL: 'ariel.christian@deltahq.com',
  PUTRI: 'putri.rahmawati@deltahq.com',
}

export default EMAILS
